import * as config from '../config';
import OptionModel from '../models/option';

export default class OptionsController {
  constructor(stepsController, stepModel) {
    this.stepsController = stepsController;
    this.step = stepModel;
    this.option = {};
  }

  draw() {
    if (!this.show()) {
      return false;
    }

    this.step.options.forEach(option => {
      this.option = new OptionModel(option);

      this.stepsController.graph.addNode(option.id, option.label);
      this.stepsController.graph.addEdge(this.step.id, option.id);
      this.stepsController.style.bindIdToClass(option.id, config.STEP_OPTION_CLASS);

      this.drawConnection();
    });

    return true;
  }

  show() {
    return this.step.options &&
           this.step.options.length > 0 &&
           this.step.jumps &&
           this.step.jumps.length === 1;
  }

  drawConnection() {
    const nextId = this.stepsController.getNextId(this.step, this.step.jumps[0]);

    if (nextId) {
      this.stepsController.graph.addEdge(this.option.id, nextId);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/controllers/options.js
 **/